import { Alert, AlertTypes } from 'types/State';
import { v4 as uuidv4 } from 'uuid';

import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';

const alertReceived = createAction<Alert>('alerts/received');

const alertFinished = createAction<string>('alerts/finished');

const ALERT_TIME = 2000;

export function displayAlert({
  type,
  message,
  debug,
  alertTime = ALERT_TIME,
}: {
  type: AlertTypes;
  message: string;
  // Misc helpful debug info, like firebase error code, etc
  debug?: string;
  alertTime?: number;
}) {
  return async (dispatch: Dispatch): Promise<void> => {
    const uuid = uuidv4();
    dispatch(alertReceived({ type, message, uuid, debug }));

    if (alertTime === Infinity) {
      return;
    }

    setTimeout(() => {
      dispatch(alertFinished(uuid));
    }, alertTime);
  };
}

export const alertReducer = createReducer<Alert[]>([], {
  [alertReceived.type]: (state, action) => {
    return [...state, action.payload];
  },
  [alertFinished.type]: (state, action) => {
    return state.filter((alert) => alert.uuid !== action.payload);
  },
});
